import React from 'react'

import type { ReactImgProps } from '../../../types'

type Props = ReactImgProps & {
  src: string
  src2x?: string
  src3x?: string
}

export function InternalImage({ src, src2x, src3x, ...props }: Props) {
  return (
    <img
      src={src}
      srcSet={getSrcSet({ src, src2x, src3x }) || undefined}
      {...props}
    />
  )
}

function getSrcSet({
  src,
  src2x,
  src3x,
}: {
  src: string
  src2x?: string
  src3x?: string
}) {
  if (!src2x && !src3x) {
    return null
  }

  return [src, src2x && `${src2x} 2x`, src3x && `${src3x} 3x`]
    .filter(s => !!s)
    .join(', ')
}
